import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, Modal} from 'react-bootstrap'
import {replace} from '../../core/extract'
import LoaderButton from '../../core/components/LoaderButton'
import {sendRemoveInterventionPeriodCmd, loadProvider, loadContact} from '../actions'
import i18n from '../i18n'
import style from './RemoveInterventionPeriodModal.less'

function isContact(committed) {
    return !!committed.commitments
}

class RemoveInterventionPeriodModal extends Component {
    static propTypes = {
        committed: PropTypes.object.isRequired,
        activity: PropTypes.object.isRequired,
        interventionPeriod: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired
    }

    _sendCmd(event) {
        const {dispatch, committed, activity, interventionPeriod, onHide} = this.props

        return dispatch(sendRemoveInterventionPeriodCmd(committed._links, activity.uid, interventionPeriod.uid)).then(() => {
            return isContact(committed) && dispatch(loadContact()) || dispatch(loadProvider())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, committed, activity, interventionPeriod, onHide, ...others} = this.props

        return (
            <Modal
                className='modal-danger'
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.remove}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={style.text}>
                        {i18n.removeInterventionPeriodText.map((text, index) => (
                            <p key={index}>{replace(text, interventionPeriod.period)}</p>
                        ))}
                    </div>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='danger'
                            bsSize='large'
                            onClick={(e) => this._sendCmd(e)}>
                            {i18n.remove}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

RemoveInterventionPeriodModal = connect()(RemoveInterventionPeriodModal)

export default RemoveInterventionPeriodModal


// WEBPACK FOOTER //
// ./lib/provider/components/RemoveInterventionPeriodModal.js